import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  ADD_CLIENT,
  DELETE_CLIENT,
  GET_CLIENT,
  GET_CLIENTS_TABLE_DATA,
  GET_CLIENT_SUCCESS_MANAGER,
  GET_EXPERIENCES_FEATURES,
  GET_LANDING_SCREEN_FEATURES,
  GET_VENDORS,
  GET_VENDORS_FOR_USER,
  GET_VENDOR_CONFIG,
  GET_VENDOR_EMAIL_CONFIG,
  GET_VENDOR_PAYMENT_CONFIG,
  POST_CLIENT_SUCCESS_MANAGER,
  UPDATE_CLIENT,
  UPDATE_CLIENT_CONFIGS,
  UPDATE_CLIENT_EMAIL_CONFIG,
  UPDATE_CLIENT_FEATURES,
  UPDATE_CLIENT_SETTINGS,
  UPDATE_CLIENT_SUCCESS_MANAGER,
  UPDATE_VENDOR_PAYMENT_CONFIG,
} from "store/clients/actionTypes"
import {
  apiError,
  getVendorsSuccess,
  updateClientConfigsSuccess,
  updateClientConfigsFail,
  getVendorPaymentConfigFailed,
  getVendorPaymentConfigSuccess,
  updateVendorPaymentConfigFailed,
  updateVendorPaymentConfigSuccess,
  getVendorsForUserSuccess,
  getVendorsForUserFailed,
} from "store/clients/actions"
import { LOCAL_STORAGE_TAGS, URL_PATHS } from "constants/index"
import {
  post,
  getVendorsAxios,
  get,
  postVendorsAxios,
  delVendorsAxios,
  axiosPut,
  patchVendorsAxios,
} from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { getFormDataFromJSON, showToast } from "../../utils"
import {
  addClientFailed,
  addClientSuccess,
  deleteClientFailed,
  deleteClientSuccess,
  getClientFailed,
  getClientsTableDataFailed,
  getClientsTableDataSuccess,
  getClientSuccess,
  getClientSuccessManagerFailed,
  getClientSuccessManagerSuccess,
  getExperiencesFeaturesFailed,
  getExperiencesFeaturesSuccess,
  getLandingScreenFeaturesFailed,
  getLandingScreenFeaturesSuccess,
  getVendorConfigFailed,
  getVendorConfigSuccess,
  getVendorEmailConfigFailed,
  getVendorEmailConfigSuccess,
  hideDeleteClientModal,
  postClientSuccessManagerFailed,
  postClientSuccessManagerSuccess,
  updateClientFailed,
  updateClientFeaturesFailed,
  updateClientFeaturesSuccess,
  updateClientSuccess,
  updateClientSuccessManagerFailed,
  updateClientSuccessManagerSuccess,
  updateClientSettingsFailed,
  updateClientSettingsSuccess,
  updateClientEmailConfigFailed,
  updateClientEmailConfigSuccess,
  getClientConfigSuccess,
  getFeaturesAvailable,
} from "store/actions"

function* getVendorsForUserSaga({ payload: { values } }) {
  try {
    const response = yield get(
      `${url.GET_VENDORS_FOR_USER_URL}?email=${values.email}`
    )
    yield put(getVendorsForUserSuccess(response))
  } catch ({ response }) {
    yield put(getVendorsForUserFailed(response))
  }
}

function* getVendorsSaga({ payload: { values } }) {
  try {
    const response = yield getVendorsAxios(`${url.GET_ADMIN_VENDORS_URL}`)
    yield put(getVendorsSuccess(response))
    yield localStorage.setItem(
      LOCAL_STORAGE_TAGS.CLIENTS_TAG,
      JSON.stringify(response)
    )
  } catch (error) {
    yield put(apiError(error))
  }
}

function* updateClientConfigs({ payload: { payload } }) {
  try {
    yield postVendorsAxios(
      url.UPDATE_CLIENT_CONFIGS + payload.vendor_id + "/configs",
      payload
    )
    yield put(updateClientConfigsSuccess())
    showToast("success", "The config(s) has been updated!", "Success")
  } catch (error) {
    yield put(updateClientConfigsFail(error))
    showToast("error", error, "Error")
  }
}

function* getClientsTableData({ payload: params }) {
  try {
    const response = yield getVendorsAxios(url.GET_ADMIN_VENDORS_URL, {
      params,
    })
    yield put(getClientsTableDataSuccess(response))
  } catch (error) {
    yield put(getClientsTableDataFailed(error))
    showToast("error", error, "Error")
  }
}

function* addClient({ payload: params }) {
  try {
    const response = yield postVendorsAxios(
      url.GET_ADMIN_VENDORS_URL,
      getFormDataFromJSON(params.client)
    )
    yield put(addClientSuccess(response))
    // post client success manager
    if (params.callback && params.clientSuccessManager) {
      params.callback({
        ...params.clientSuccessManager,
        vendor_id: response.id,
      })
    }
    params.history.push(URL_PATHS.CLIENTS)
    showToast("success", "Client added!", "Success")
  } catch (error) {
    yield put(addClientFailed(error))
    showToast("error", error, "Error")
  }
}

function* postClientSuccessManager({ payload: params }) {
  try {
    const response = yield post(url.ADMIN_CLIENT_SUCCESS_MANAGER_URL, params)
    yield put(postClientSuccessManagerSuccess(response))
    showToast("success", "Client success manager created!", "Success")
  } catch (error) {
    yield put(postClientSuccessManagerFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteClient({ payload: params }) {
  try {
    const response = yield delVendorsAxios(
      `${url.UPDATE_CLIENT_CONFIGS}${params.id}`
    )
    yield put(deleteClientSuccess(response))
    if (params.callback) {
      params.callback()
    }
    yield put(hideDeleteClientModal())
    showToast("success", "Client deleted!", "Success")
  } catch (error) {
    yield put(deleteClientFailed(error))
    yield put(hideDeleteClientModal())
    showToast("error", error, "Error")
  }
}

function* getClient({ payload: params }) {
  try {
    const response = yield getVendorsAxios(
      `${url.GET_ADMIN_VENDORS_URL}/${params.id}`
    )
    yield put(getClientSuccess(response))
  } catch (error) {
    yield put(getClientFailed(error))
    showToast("error", error, "Error")
  }
}

function* getClientSuccessManager({ payload: params }) {
  try {
    const response = yield get(url.CLIENT_SUCCESS_MANAGER_URL, { params })
    yield put(getClientSuccessManagerSuccess(response))
  } catch (error) {
    yield put(getClientSuccessManagerFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateClient({ payload: params }) {
  try {
    const response = yield postVendorsAxios(
      `${url.UPDATE_CLIENT_CONFIGS}${params.id}`,
      getFormDataFromJSON(params.values)
    )
    yield put(updateClientSuccess(response))
    params.history.push(URL_PATHS.CLIENTS)
    showToast("success", "Client updated!", "Success")
  } catch (error) {
    yield put(updateClientFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateClientSuccessManager({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.ADMIN_CLIENT_SUCCESS_MANAGER_URL}/${params.id}`,
      params.values
    )
    yield put(updateClientSuccessManagerSuccess(response))
    showToast("success", "Client success manager updated!", "Success")
  } catch (error) {
    yield put(updateClientSuccessManagerFailed(error))
    showToast("error", error, "Error")
  }
}

function* getVendorConfig({ payload: params }) {
  try {
    const response = yield getVendorsAxios(
      `${url.GET_ADMIN_VENDORS_URL}/${params.id}/config`,
      { params: { vendor_id: params.id } }
    )
    yield put(getVendorConfigSuccess(response))
  } catch (error) {
    yield put(getVendorConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* getVendorEmailConfig({ payload: params }) {
  try {
    const response = yield getVendorsAxios(
      `/vendors/${params.id}/email-config`,
      { params: { vendor_id: params.id } }
    )
    yield put(getVendorEmailConfigSuccess(response))
  } catch (error) {
    yield put(getVendorEmailConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* getExperinecesFeatures({ payload: params }) {
  try {
    const response = yield get(`${url.GET_FEATURES_URL}${params.id}`, {
      params: params.values,
    })
    yield put(getExperiencesFeaturesSuccess(response))
  } catch (error) {
    yield put(getExperiencesFeaturesFailed(error))
    showToast("error", error, "Error")
  }
}

function* getLandingScreenFeatures({ payload: params }) {
  try {
    const response = yield get(`${url.GET_FEATURES_URL}${params.id}`, {
      params: params.values,
    })
    yield put(getLandingScreenFeaturesSuccess(response))
  } catch (error) {
    yield put(getLandingScreenFeaturesFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateClientFeatures({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.GET_FEATURES_URL}${params.id}`,
      params.values
    )
    if (params?.isLoggedInVendor) {
      yield put(getFeaturesAvailable())
    }
    yield put(updateClientFeaturesSuccess(response))
    showToast("success", "Client features updated!", "Success")
  } catch (error) {
    yield put(updateClientFeaturesFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateClientSettings({ payload: { updateLocalStorage, params } }) {
  try {
    const response = yield patchVendorsAxios(
      url.UPDATE_CLIENT_CONFIGS + params.vendor_id + "/config",
      params
    )
    yield put(updateClientSettingsSuccess(response))
    if (updateLocalStorage) {
      yield localStorage.setItem(
        LOCAL_STORAGE_TAGS.CONFIG_TAG,
        JSON.stringify(params)
      )
      yield put(getClientConfigSuccess(params))
    }
    showToast("success", "Client settings updated!", "Success")
  } catch (error) {
    yield put(updateClientSettingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateClientEmailConfig({ payload: params }) {
  try {
    const response = yield postVendorsAxios(
      url.UPDATE_CLIENT_CONFIGS + params.vendor_id + "/email-config",
      getFormDataFromJSON(params)
    )
    yield put(updateClientEmailConfigSuccess(response))
    showToast("success", "Client Email Settings updated!", "Success")
  } catch (error) {
    yield put(updateClientEmailConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* getVendorPaymentConfig({ payload: params }) {
  try {
    const response = yield getVendorsAxios(
      `/admin/vendors/${params?.id}/payment-config`
    )
    yield put(getVendorPaymentConfigSuccess(response))
  } catch (error) {
    yield put(getVendorPaymentConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateVendorPaymentConfig({ payload: params }) {
  try {
    const response = yield postVendorsAxios(
      `/admin/vendors/${params?.vendor_id}/payment-config`,
      params
    )
    yield put(updateVendorPaymentConfigSuccess(response))
    showToast("success", "Payment configs updated", "Success")
  } catch (error) {
    yield put(updateVendorPaymentConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* clientsSaga() {
  yield takeEvery(GET_VENDORS_FOR_USER, getVendorsForUserSaga)
  yield takeEvery(GET_VENDORS, getVendorsSaga)
  yield takeEvery(UPDATE_CLIENT_CONFIGS, updateClientConfigs)
  yield takeEvery(GET_CLIENTS_TABLE_DATA, getClientsTableData)
  yield takeEvery(ADD_CLIENT, addClient)
  yield takeEvery(POST_CLIENT_SUCCESS_MANAGER, postClientSuccessManager)
  yield takeEvery(DELETE_CLIENT, deleteClient)
  yield takeEvery(GET_CLIENT, getClient)
  yield takeEvery(GET_CLIENT_SUCCESS_MANAGER, getClientSuccessManager)
  yield takeEvery(UPDATE_CLIENT, updateClient)
  yield takeEvery(UPDATE_CLIENT_SUCCESS_MANAGER, updateClientSuccessManager)
  yield takeEvery(GET_VENDOR_CONFIG, getVendorConfig)
  yield takeEvery(GET_VENDOR_EMAIL_CONFIG, getVendorEmailConfig)
  yield takeEvery(GET_EXPERIENCES_FEATURES, getExperinecesFeatures)
  yield takeEvery(GET_LANDING_SCREEN_FEATURES, getLandingScreenFeatures)
  yield takeEvery(UPDATE_CLIENT_FEATURES, updateClientFeatures)
  yield takeEvery(UPDATE_CLIENT_SETTINGS, updateClientSettings)
  yield takeEvery(UPDATE_CLIENT_EMAIL_CONFIG, updateClientEmailConfig)
  yield takeEvery(GET_VENDOR_PAYMENT_CONFIG, getVendorPaymentConfig)
  yield takeEvery(UPDATE_VENDOR_PAYMENT_CONFIG, updateVendorPaymentConfig)
}

export default clientsSaga
